/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Stack, Typography } from '@mui/material';
import {
  DateField,
  FunctionField,
  ResourceProps,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TopToolbar,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowController,
} from 'react-admin';
import { FC, useState } from 'react';

import { DealStatusEnum } from 'api/generated';
import { DealStatusTranslate } from 'config/locale';
import { Link as RouterLink } from 'react-router-dom';
import { api } from 'api';

const DisputesShowActions = () => {
  const record = useRecordContext<any>();
  const notify = useNotify();
  const refresh = useRefresh();
  const [isCustomerConfirmOpen, setIsCustomerConfirmOpen] = useState(false);

  const resolveInFavorOfCustomer = async () => {
    if (!record?.id) {
      return;
    }
    try {
      await api.V1AdminsDisputesApi.adminDisputeControllerResolveInFavorOfCustomer(record.id);
      notify('Спор решен в пользу заказчика');
      refresh();
    } catch (error: any) {
      notify('Не удалось решить спор - проверьте его статус', { type: 'error' });
    } finally {
      setIsCustomerConfirmOpen(false);
    }
  };

  const resolveInFavorOfExecutor = async () => {
    if (!record?.id) {
      return;
    }
    try {
      await api.V1AdminsDisputesApi.adminDisputeControllerResolveInFavorOfExecutor(record.id);
      notify('Спор решен в пользу исполнителя');
      refresh();
    } catch (error: any) {
      notify('Не удалось решить спор - проверьте его статус', { type: 'error' });
    }
  };

  return (
    <>
      <TopToolbar>
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            color="error"
            onClick={() => setIsCustomerConfirmOpen(true)}
            disabled={!record?.id}>
            Вернуть деньги заказчику
          </Button>
          <Button variant="contained" onClick={() => resolveInFavorOfExecutor()} disabled={!record?.id}>
            Выплатить деньги исполнителю
          </Button>
        </Stack>
      </TopToolbar>
      <Dialog open={isCustomerConfirmOpen} onClose={() => setIsCustomerConfirmOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Подтверждение</DialogTitle>
        <DialogContent>
          <Typography>
            Перед решением спора в сторону Заказчика убедитесь, что вернули ему деньги в ЛК Монеты.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsCustomerConfirmOpen(false)}>Отмена</Button>
          <Button variant="contained" color="error" onClick={() => resolveInFavorOfCustomer()}>
            Подтвердить
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const DisputesShow: FC<ResourceProps> = (props) => {
  const { record } = useShowController();

  return (
    <Show title="Спор" {...props} actions={record?.isResolved ? undefined : <DisputesShowActions />}>
      <TabbedShowLayout>
        <Tab label="О Споре">
          <TextField source="id" label="ID Спора" />
          <TextField source="deal.id" label="ID Сделки" />
          <FunctionField
            label="Статус сделки"
            source="deal.status"
            render={(dispute: any) => {
              return DealStatusTranslate[dispute?.deal?.status as DealStatusEnum] || 'Неизвестный статус';
            }}
          />{' '}
          <TextField source="paymentOperationExternalId" emptyText="-" label="Номер операции в Монете" />
          <TextField source="deal.ad.owner.phone" label="Заказчик" />
          <FunctionField
            label="ID заказчика"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            render={(dispute: any) => {
              const userId = dispute?.deal?.ad?.owner?.id;

              if (!userId) {
                return '-';
              }

              return (
                <Link component={RouterLink} to={`/users/${userId}/show`} underline="hover">
                  {userId}
                </Link>
              );
            }}
          />
          <TextField source="deal.executionRequest.user.phone" label="Исполнитель" emptyText="Нет телефона" />
          <FunctionField
            label="ID исполнителя"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            render={(dispute: any) => {
              const userId = dispute?.deal?.executionRequest?.user?.id;

              if (!userId) {
                return '-';
              }

              return (
                <Link component={RouterLink} to={`/users/${userId}/show`} underline="hover">
                  {userId}
                </Link>
              );
            }}
          />
          <TextField source="description" label="Комментарий" />
          <FunctionField
            label="Статус спора"
            source="deal.status"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            render={(dispute: any) => {
              return dispute?.isResolved ? 'Завершен' : 'Открыт';
            }}
          />
          <DateField locales="rus" label="Дата открытия спора" source="createdAt" />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default DisputesShow;
